export default "__VITE_ASSET__2e57e38a__"